
export default function PeopleComponent ({amount, style, images}) {
  if (!amount || amount < 0 || amount > 20 || !images) {
    return []
  }

  return <img src={images[amount]} style={style} role="presentation" alt="" />
}